import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useSelector } from "react-redux";
import axios from "../../helper/axios";

const formatOrderDate = (value) => {
	if (!value) return null;
	const date = new Date(value);
	if (Number.isNaN(date.getTime())) return null;
	const day = String(date.getDate()).padStart(2, "0");
	const month = String(date.getMonth() + 1).padStart(2, "0");
	const year = date.getFullYear();
	return `${day}/${month}/${year}`;
};

export default function MyOrdersTab() {
	const auth = useSelector(state => state?.productData?.users);
	const [orderData, setOrderData] = useState([]);
	const [expanded, setExpanded] = useState(null)
	const getApiData = async () => {
		const data = { email: auth?.user?.email }
		const res = await axios.post("/getmyorder", data);
		setOrderData(res?.data);
	}

	const toggle = (index) => {
		if (expanded === index) {
			return setExpanded(null)
		}
		setExpanded(index)
	};

	useEffect(() => {
		getApiData();
	}, [])

	return (
		<>
			{/* <div className="flex-col w-full space-y-2">
				<div className="bg-white p-5">
					<h2>Porositë e mija ({orderData?.length})</h2>
				</div>
				<div className="tabdetailsx bg-white p-2 flex flex-col ">
					{orderData?.length > 0 ?
						orderData?.map((dt, index) => (
							<div className='order_wrapper' key={index}>
								<button onClick={() => toggle(index)} className="ordertabbt flex border-b  rounded-md justify-between items-center  w-full text-left">
									<p>Order Id: #{dt?.orderId}</p>
									<p>{expanded === index ? "-" : "+"}</p>
								</button>
								{expanded === index ? dt?.productList?.map((pl, indx) => (
									<div className="tab_conatnt  border-[#ebe7e8]" key={indx}>
										<div className="flex space-x-2 justify-between">
											<div className="flex space-x-2">
												<img src={pl?.images[0]} className="h-12 w-12 rounded-md" alt='' />
												<div className="flex-col space-y-1">
													<h1 className="text-sm">{pl?.name}</h1>
													<p className="text-xs">Qty: {pl?.quantity}</p>
												</div>
											</div>
											<div>{pl?.sale_price != 0 ? pl?.sale_price + " €" : pl?.regular_price + " €"}</div>
										</div>
									</div>
								)) : ""}
							</div>
						))
						:
						<div className="flex flex-col justify-center items-center">
							<div>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									className="icon icon-tabler icon-tabler-hanger"
									width={64}
									height={64}
									viewBox="0 0 24 24"
									strokeWidth={2}
									stroke="rgb(107 114 128)"
									fill="none"
									strokeLinecap="round"
									strokeLinejoin="round"
								>
									<path stroke="none" d="M0 0h24v24H0z" fill="none" />
									<path d="M14 6a2 2 0 1 0 -4 0c0 1.667 .67 3 2 4h-.008l7.971 4.428a2 2 0 0 1 1.029 1.749v.823a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-.823a2 2 0 0 1 1.029 -1.749l7.971 -4.428" />
								</svg>
							</div>
							<h2 className="uppercase rgba(71,85,105) p-14">You currently have no Orders</h2>
							<Link to="/">
								<button className="bg-[#fca700] py-2 px-2 text-white">START SHOPPING</button>
							</Link>
						</div>}
				</div>
			</div> */}

			<div className="w-full">
				<div className="rounded-2xl border border-neutral-200 bg-white p-5 sm:p-6 space-y-5">
					<p className="text-sm text-neutral-500">
						Lista e porosive ({orderData?.length || 0})
					</p>


					<div className="space-y-4">
						{orderData?.length > 0 ? (
							orderData?.map((dt, index) => {
								// Calculate grand total for this order
								let grandTotal = dt?.productList?.reduce((acc, pl) => {
									const price = pl?.sale_price !== 0 ? pl?.sale_price : pl?.regular_price;
									return acc + price * pl?.quantity;
								}, 0);

								// Add delivery cost
								grandTotal += dt?.deliverMode || 0;
								const createdDate = formatOrderDate(dt?.createdAt);

								return (
									<div className="border border-gray-200 rounded-md" key={index}>
										<button
											onClick={() => toggle(index)}
											className="w-full flex justify-between items-center p-4 text-left bg-gray-50 hover:bg-gray-100 rounded-md transition"
										>
											<div>
												<p className="text-sm text-gray-700 font-medium">
													ID e Porosisë: <span className="text-gray-900">#{dt?.orderId}</span>
												</p>
												{createdDate ? (
													<p className="text-[11px] text-gray-500 mt-0.5">
														Data e Porosisë: {createdDate}
													</p>
												) : null}
											</div>
											<div className="text-sm font-semibold text-gray-900">
												Grand Total: {grandTotal.toFixed(2)} €
											</div>
											<div className="text-xl font-bold text-gray-600">{expanded === index ? "−" : "+"}</div>
										</button>

										{expanded === index && (
											<div className="space-y-3 px-4 pb-4">
												{dt?.productList?.map((pl, indx) => {
													const price = pl?.sale_price !== 0 ? pl?.sale_price : pl?.regular_price;
													const totalItemPrice = price * pl?.quantity;
													return (
														<div
															key={indx}
															className="flex items-center justify-between border-t pt-3"
														>
															<div className="flex items-center space-x-3">
																<img
																	src={pl?.images?.[0]}
																	alt=""
																	className="h-14 w-14 rounded-md border object-cover"
																/>
																<div className="flex flex-col">
																	<h3 className="text-sm font-medium text-gray-800">{pl?.name}</h3>
																	<p className="text-xs text-gray-500">
																		Sasia: {pl?.quantity} × {price} €
																	</p>
																</div>
															</div>
															<div className="text-sm font-semibold text-gray-700">
																{totalItemPrice.toFixed(2)} €
															</div>
														</div>
													);
												})}
												<div className="pt-3 border-t text-right font-bold text-gray-900">
													Grand Total: {grandTotal.toFixed(2)} €
												</div>
											</div>
										)}
									</div>
								);
							})
						) : (
							<div className="flex flex-col justify-center items-center py-12 text-center">
								<svg
									xmlns="http://www.w3.org/2000/svg"
									className="icon icon-tabler icon-tabler-hanger mb-6 text-gray-400"
									width={64}
									height={64}
									viewBox="0 0 24 24"
									strokeWidth={2}
									stroke="rgb(107 114 128)"
									fill="none"
									strokeLinecap="round"
									strokeLinejoin="round"
								>
									<path stroke="none" d="M0 0h24v24H0z" fill="none" />
									<path d="M14 6a2 2 0 1 0 -4 0c0 1.667 .67 3 2 4h-.008l7.971 4.428a2 2 0 0 1 1.029 1.749v.823a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-.823a2 2 0 0 1 1.029 -1.749l7.971 -4.428" />
								</svg>
								<h2 className="text-gray-500 text-lg font-medium mb-4">Nuk keni bërë asnjë porosi</h2>
								<Link to="/">
									<button className="bg-neutral-900 hover:bg-neutral-800 text-white py-2.5 px-4 rounded-lg transition">
										Filloni blerjen
									</button>
								</Link>
							</div>
						)}
					</div>




					{/* <div className="space-y-4">
						{orderData?.length > 0 ? (
							orderData?.map((dt, index) => {
								var totalPricex = 0;
								totalPricex = dt?.productList[0]?.totalPrice;
								totalPricex += dt?.deliverMode;
								return (
									<div className="border border-gray-200 rounded-md" key={index}>
										<button
											onClick={() => toggle(index)}
											className="w-full flex justify-between items-center p-4 text-left bg-gray-50 hover:bg-gray-100 rounded-md transition"
										>
											<div>
												<p className="text-sm text-gray-700 font-medium">
													ID e Porosisë: <span className="text-gray-900">#{dt?.orderId}</span>
												</p>
												<p className="text-xs text-gray-500">Produkte: {dt?.productList?.length}</p>
											</div>
											<div className="text-xl font-bold text-gray-600">{expanded === index ? "−" : "+"}</div>
										</button>

										{expanded === index && (
											<div className="space-y-3 px-4 pb-4">
												{dt?.productList?.map((pl, indx) => (
													<div
														key={indx}
														className="flex items-center justify-between border-t pt-3"
													>
														<div className="flex items-center space-x-3">
															<img
																src={pl?.images?.[0]}
																alt=""
																className="h-14 w-14 rounded-md border object-cover"
															/>
															<div className="flex flex-col">
																<h3 className="text-sm font-medium text-gray-800">
																	{pl?.name}
																</h3>
																<p className="text-xs text-gray-500">
																	Sasia: {pl?.quantity}
																</p>
															</div>
														</div>
														<div className="text-sm font-semibold text-gray-700">
															{pl?.sale_price !== 0
																? `${pl?.sale_price} €`
																: `${pl?.regular_price} €`}
														</div>
													</div>
												))}
											</div>
										)}
									</div>
								)
							})
						) : (
							<div className="flex flex-col justify-center items-center py-12 text-center">
								<svg
									xmlns="http://www.w3.org/2000/svg"
									className="icon icon-tabler icon-tabler-hanger mb-6 text-gray-400"
									width={64}
									height={64}
									viewBox="0 0 24 24"
									strokeWidth={2}
									stroke="rgb(107 114 128)"
									fill="none"
									strokeLinecap="round"
									strokeLinejoin="round"
								>
									<path stroke="none" d="M0 0h24v24H0z" fill="none" />
									<path d="M14 6a2 2 0 1 0 -4 0c0 1.667 .67 3 2 4h-.008l7.971 4.428a2 2 0 0 1 1.029 1.749v.823a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-.823a2 2 0 0 1 1.029 -1.749l7.971 -4.428" />
								</svg>
								<h2 className="text-gray-500 text-lg font-medium mb-4">
									Nuk keni bërë asnjë porosi
								</h2>
								<Link to="/">
									<button className="bg-yellow-500 hover:bg-yellow-600 text-white py-2 px-4 rounded-md transition">
										FILLONI BLERJEN
									</button>
								</Link>
							</div>
						)}
					</div> */}

				</div>
			</div>

		</>
	)
}